import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { numberFormatter } from '../../../../../utils/number';
import tripExpenseBasicInformationPropTypes from '../proptypes/TripExpensePropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';

const TripExpenseBasicInformationResource = ({
  documentSeries,
  date,
  driverFullName,
  companyBusId,
  itinerarySourceAndDestination,
  tollPayment,
  commissionPayment,
  totalPayment
}) => (
  <>
    <ResourceProperty label="Correlativo:">
      {documentSeries}
    </ResourceProperty>
    <ResourceProperty label="Fecha:">
      {tzNormalizeDate({ date, format: DATE_TIME_FORMAT})}
    </ResourceProperty>
      <ResourceProperty label="Nombre:">
        {driverFullName}
      </ResourceProperty>
      <ResourceProperty label="Número de Bus:">
        {companyBusId}
      </ResourceProperty>
      <ResourceProperty label="Origen / Destino:">
        {itinerarySourceAndDestination}
      </ResourceProperty>
    <ResourceProperty label="Peajes:">
      {numberFormatter({
        value: tollPayment,
        style: 'currency',
      })}
    </ResourceProperty>
    <ResourceProperty label="Condiciones de Trabajo:">
      {numberFormatter({
        value: commissionPayment,
        style: 'currency',
      })}
    </ResourceProperty>
    <ResourceProperty label="Total:">
      {numberFormatter({
        value: totalPayment,
        style: 'currency',
      })}
    </ResourceProperty>
  </>
);

TripExpenseBasicInformationResource.propTypes =
  tripExpenseBasicInformationPropTypes;

export default TripExpenseBasicInformationResource;
